import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable()
export class AppointmentRequestResultService {
  private appointmentRequestResultsURL = 'appointment_request_results';

  constructor(private httpClient: HttpClientService) {}

  getFormOptions(): Promise<any> {
    return this.httpClient
      .get(this.appointmentRequestResultsURL + '.json', {
        get_form_options: true,
      })
      .catch(function () {});
  }

  getAppointmentRequestResults(data: any): Promise<any> {
    return this.httpClient.get(this.appointmentRequestResultsURL + '.json', data).catch(function () {});
  }

  getAppointmentRequestResult(appointmentRequestResultId: number, data: any): Promise<any> {
    return this.httpClient.get(this.appointmentRequestResultsURL + '/' + appointmentRequestResultId + '.json', data).catch(function () {});
  }

  createAppointmentRequestResult(data: any): Promise<any> {
    return this.httpClient.post(this.appointmentRequestResultsURL + '.json', data).catch(function () {});
  }

  updateAppointmentRequestResult(appointmentRequestResultId: number, data: any): Promise<any> {
    return this.httpClient.put(this.appointmentRequestResultsURL + '/' + appointmentRequestResultId + '.json', data).catch(function () {});
  }
}
